export const PROFILEMODAL = {
  display: "DISPLAY_PROFILEMODAL",
  hide: "HIDE_PROFILEMODAL",
  toggle: "TOGGLE_PROFILEMODAL",
};

export const ACCOUNT = {
  display: "DISPLAY_ACCOUNT",
  hide: "HIDE_ACCOUNT",
};

export const BILLING = {
  display: "DISPLAY_BILLING",
  hide: "HIDE_BILLING",
};

export const PATIENT_CALLS = {
  display: "DISPLAY_PATIENT_CALLS",
  hide: "HIDE_PATIENT_CALLS",
};

export const INSIGHTS = {
  display: "DISPLAY_INSIGHTS",
  hide: "HIDE_INSIGHTS",
};

export const TEAM_MEMBERS = {
  display: "DISPLAY_TEAM_MEMBERS",
  hide: "HIDE_TEAM_MEMBERS",
};

export const CALL_SCRIPTS = {
  display: "DISPLAY_CALL_SCRIPTS",
  hide: "HIDE_CALL_SCRIPTS",
};

export const VERIFICATIONS = {
  display: "DISPLAY_VERIFICATIONS",
  hide: "HIDE_VERIFICATIONS",
};

export const REQUEST = {
  display: "DISPLAY_REQUEST",
  hide: "HIDE_REQUEST",
};

export const NEW_REQUEST_PAGE = {
  display: "DISPLAY_NEW_REQUEST_PAGE",
  hide: "HIDE_NEW_REQUEST_PAGE",
};

export const INBOX = {
  current_user_inbox: "CURRENT_USER_INBOX",
  team_inbox: "TEAM_INBOX",
  search_inbox: "SEARCH_INBOX",
};

export const FETCH_REQUEST = {
  sent: "FETCH_REQUEST_SENT",
  success: "FETCH_REQUEST_SUCCESS",
  failure: "FETCH_REQUEST_FAILURE",
};

export const SPECIALTY = {
  dental: "DENTAL",
  medical: "MEDICAL",
  mental_health: "MENTAL_HEALTH",
  medical_and_dental: "MEDICAL_AND_DENTAL",
};

export const ACCOUNTSAVED = {
  display: "DISPLAY_ACCOUNTSAVED",
  hide: "HIDE_ACCOUNTSAVED",
};
